import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useParams, useNavigate, Outlet } from 'react-router-dom';

// 액션 임포트
import { unloadChance, viewChance, chanceEstimateActive, chanceOrderCount } from '../../modules/chanceModule/chance';

// 컴포넌트 임포트
import ChanceTemplate from '../../components/chancemng/ChanceTemplate';
import ChanceInfoContainer from './info/ChanceInfoContainer';
import ChanceStepperContainer from '../../containers/chancemng/setpper/ChanceStepperContainer';

const ChanceContainer = () => {
  const { id, step, tab } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);
  const [activeTap, setActiveTap] = useState(0);

  // 리덕스 상태 통합 구독
  const { chance, estimate, count, error, loading } = useSelector(
    ({ chanceModule, projectModule, loading }) => ({
      chance: chanceModule?.chance?.chance,
      error: chanceModule?.chance?.error,
      estimate: chanceModule?.chance?.activeEstimate,
      count: chanceModule?.chance?.orderCount,
      loading: loading['chance/VIEW_CHANCE'],
    }),
    shallowEqual
  );

  // 1. URL 파라미터 동기화
  useEffect(() => {
    if (step) setActiveStep(Number(step) - 1);
    if (tab) setActiveTap(Number(tab) - 1);
  }, [step, tab]);

  // 2. 초기 데이터 및 ID 변경 시 호출
  useEffect(() => {
    if (id) {
      dispatch(viewChance(id));
      dispatch(chanceEstimateActive(id));
      dispatch(chanceOrderCount(id));
    }
    return () => dispatch(unloadChance());
  }, [dispatch, id]);

  const handleTabChange = (event, newValue) => {
    navigate(`/chancemng/${id}/${step}/${newValue + 1}`);
  };

  const handleGoBack = () => navigate('/chancemng');

  return (
    <ChanceTemplate chance={chance} loading={loading} error={error}>
      {/* 부모가 가진 최신 데이터를 자식들에게 Props로 전달 */}
      <ChanceInfoContainer 
        handleGoBack={handleGoBack} 
        estimate={estimate} 
        orderCount={count} 
      />
      <ChanceStepperContainer 
        activeStep={activeStep} 
        activeTap={activeTap} 
        handleTabChange={handleTabChange} 
      />
      <Outlet />
    </ChanceTemplate>
  );
};

export default ChanceContainer;
